
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fursys",
      function () {
        return require("private-next-pages/fursys/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fursys"])
      });
    }
  